import { render, staticRenderFns } from "./itemInfo.vue?vue&type=template&id=2950ca44&"
import script from "./itemInfo.vue?vue&type=script&lang=js&"
export * from "./itemInfo.vue?vue&type=script&lang=js&"
import style0 from "./itemInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports